import { Path, Permission } from "enums";
import PriceBuildUpModule from "modules/price-build-up/price-build-up.module";
import PriceBuildUpAddModule from "modules/price-build-up/price-build-up-add/price-build-up-add.module";
import PriceBuildUpViewModule from "modules/price-build-up/price-build-up-view/price-build-up-view.module";
import PriceBuildUpEditModule from "modules/price-build-up/price-build-up-edit/price-build-up-edit.module";
import { PermissionRoute } from "components/commons";
import React from "react";
import { Redirect } from "react-router-dom";
import { Route, Switch } from "react-router-dom/cjs/react-router-dom.min";

const PriceBuildUpPage = () => {
  return (
    <Switch>
      <Route exact path={Path.PriceBuildUpList} component={PriceBuildUpModule} />
      <PermissionRoute
        exact
        path={Path.AddPriceBuildUp}
        permission={Permission.PbuCreate}
        redirectTo={Path.PriceBuildUpList}
        component={PriceBuildUpAddModule}
      />
      <Route exact path={Path.ViewPriceBuildUp} component={PriceBuildUpViewModule} />
      <PermissionRoute
        exact
        path={Path.EditPriceBuildUp}
        permission={Permission.PbuEdit}
        redirectTo={Path.PriceBuildUpList}
        component={PriceBuildUpEditModule}
      />
      <Redirect to={Path.PriceBuildUpList} />
    </Switch>
  );
};

export default PriceBuildUpPage;
